exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tipsWrapper[data-v-c76a4b38] {\n  height: 0.75rem;\n  line-height: 0.75rem;\n  overflow: hidden;\n}\n.tips[data-v-c76a4b38] {\n  color: #B78932;\n}", ""]);

// exports
